<form [formGroup]="userForm">
    <div class="form-row">
        <div class="form-item">
                <p>First name</p>
                <mat-form-field class="form-field-width-md">
                    <input autocomplete="off" matInput formControlName="firstName" id="currentName" required>
                </mat-form-field>
                <mat-error *ngIf="!userForm.get('firstName').valid && userForm.controls['firstName']?.touched">Enter name</mat-error>
        </div>
        <div class="form-item">
            <p>Current age</p>
            <mat-form-field class="form-field-width-md">
                <input autocomplete="off" type="number" matInput formControlName="currentAge" id="currentAge" (change)="adjRetirementAge()" required>
            </mat-form-field>
            <mat-error *ngIf="!userForm.get('currentAge').valid && userForm.controls['currentAge']?.touched">Enter age between 18 and 70</mat-error>
        </div>
        <div class="form-item">
            <p>Retirement age</p>
            <mat-form-field class="form-field-width-md">
                <input autocomplete="off" type="number" matInput formControlName="retirementAge" id="retirementAge" (change)="adjRetirementAge()" required>
                <mat-error *ngIf="!userForm.get('retirementAge').valid && userForm.controls['retirementAge']?.touched">Please enter a retirement age between {{minRetirementAge}} and 90</mat-error>
            </mat-form-field>
        </div>
    </div>
</form>
